<template>
  <div class="unit-buttons">
    <div
      v-for="({ label, value }) in unitButtons"
      :key="label"
      class="unit-button"
      :class="{
        selected: value === selectedUnit,
        'mr-2': value !== 'quarter',
      }"
      @click="$emit('update', value)"
    >
      <span>{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnitButtons',
  props: {
    selectedUnit: {
      type: String,
      required: true,
    },
  },
  emits: ['update'],
  data() {
    return {
      unitButtons: [
        {
          label: 'Week',
          value: 'week',
        },
        {
          label: 'Month',
          value: 'month',
        },
        {
          label: 'Quarter',
          value: 'quarter',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.unit-buttons {
  width: 100%;
  margin: 50px 0px 36px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unit-button {
  border-radius: 8px;
  background: @white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  border: 1px solid @grey-900;

  span {
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    color: @text-darkest;
  }

  &:not(.selected):hover {
    background: @bg-brand-default;

    span {
      color: @white;
    }
  }

  &.selected {
    border: 1px solid @brand-primary;

    span {
      color: @text-brand;
      font-weight: 400;
    }
  }

  &.disabled {
    border: 1px solid @stroke-default;

    span {
      color: @grey-500;
      font-weight: 300;
    }
  }
}
</style>
